import { useState } from "react";
import { BasketBlackIcon, HandIcon, SortIcon } from "../../../assets/icons";
import { LocalSettingsDTO } from "../../../models/local/local.response";
import { Link } from "react-router-dom";

interface ClientMenuButtonsProps {
    setIsFiltersViewOpen: (isOpen: boolean) => void;
    setIsBasketViewOpen: (isOpen: boolean) => void;
    callingWaiter?: boolean;
    callWaiterAsync?: () => Promise<void>;
    planSubscriptionFeatures: string[];
    primaryColor: string;
    cartProductsCount: number;
    onlineMenu: boolean;
    localSettings: LocalSettingsDTO;
    setIsLocalInfoViewOpen: (isOpen: boolean) => void;
    setIsClientOrdersViewOpen: (isOpen: boolean) => void;
    setIsReservationViewOpen: (isOpen: boolean) => void;
    isUserLoggedIn: boolean;
}

export default function ClientMenuButtons({ setIsFiltersViewOpen, setIsBasketViewOpen, primaryColor, cartProductsCount, planSubscriptionFeatures, callingWaiter, callWaiterAsync, localSettings, setIsLocalInfoViewOpen, setIsClientOrdersViewOpen, setIsReservationViewOpen, isUserLoggedIn }: ClientMenuButtonsProps) {

    const [isMoreOptionsOpen, setIsMoreOptionsOpen] = useState(false);

    return (
        <section className="client-buttons-section" >
            <div className="w-layout-blockcontainer container client-buttons w-container">
                <div className="client-buttons-wrapper">
                    <div className="client-buttons-list-div" style={{ justifyContent: "space-around" }}>
                        <div className="client-button-div" onClick={() => setIsFiltersViewOpen(true)}>
                            <img src={SortIcon} loading="lazy" alt="" className="client-button-icon" />
                            <div className="description-text">Filtriraj</div>
                        </div>

                        {planSubscriptionFeatures.some(f => f.startsWith("pro")) && callWaiterAsync && (
                            <div className="client-button-div"
                                onClick={() => callWaiterAsync()}>
                                <img src={HandIcon} loading="lazy" alt="" className="client-button-icon" />
                                <div className="description-text">Pozovi konobara</div>
                                {callingWaiter && (
                                    <div className="client-button-notify-div call-waiter" style={callingWaiter ? { animation: "pulse 1.5s infinite" } : {}}>
                                    </div>
                                )}
                            </div>
                        )}

                        <div className="client-button-div" onClick={() => setIsBasketViewOpen(true)}>
                            <img src={BasketBlackIcon} loading="lazy" alt="" className="client-button-icon" />
                            <div className="description-text">Korpa</div>
                            {cartProductsCount > 0 && (
                                <div className="client-button-notify-div" style={{ background: primaryColor }}>
                                    <div>{cartProductsCount}</div>
                                </div>
                            )}
                        </div>

                        <div className="client-button-div more-options" onClick={() => setIsMoreOptionsOpen(!isMoreOptionsOpen)}>
                            <svg className="client-button-icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor"><circle cx="12" cy="12" r="2"></circle><circle cx="12" cy="5" r="2"></circle><circle cx="12" cy="19" r="2"></circle></svg>
                            <div className="description-text">Više opcija</div>
                        </div>

                    </div>

                    <div className="client-button-more-option-list" style={{ display: isMoreOptionsOpen ? "block" : "none" }}>
                        <div className="w-layout-blockcontainer container client-button-more-option w-container">

                            {planSubscriptionFeatures.includes("plus-reservation") && (
                                <div className="client-button-more-option-div" onClick={() => {
                                    setIsReservationViewOpen(true);
                                    setIsMoreOptionsOpen(false);
                                }}>
                                    <div>Rezervacije</div>
                                    <svg className="client-button-more-option-icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke={primaryColor} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect><line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line><line x1="3" y1="10" x2="21" y2="10"></line></svg>
                                </div>
                            )}

                            {planSubscriptionFeatures.some(f => f.startsWith("plus-order")) && (
                                <div className="client-button-more-option-div" onClick={() => {
                                    setIsClientOrdersViewOpen(true);
                                    setIsMoreOptionsOpen(false);
                                }}>
                                    <div>Moje porudžbine u lokalu</div>
                                    <svg className="client-button-more-option-icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke={primaryColor} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path><line x1="3" y1="6" x2="21" y2="6"></line><path d="M16 10a4 4 0 0 1-8 0"></path></svg>
                                </div>
                            )}

                            <div className="client-button-more-option-div" onClick={() => {
                                setIsLocalInfoViewOpen(true);
                                setIsMoreOptionsOpen(false);
                            }}>
                                <div>O lokalu</div>
                                <svg className="client-button-more-option-icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke={primaryColor} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg>
                            </div>

                            {isUserLoggedIn ? (
                                <Link to="/client-profile" className="client-button-more-option-div profil" style={{ "backgroundColor": `${primaryColor}`, "textDecoration": "none" }}>
                                    <div className="text-block-53">Profil</div>
                                    <svg className="client-button-more-option-icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#ffff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>
                                </Link>
                            ) : (
                                <Link to="/login" className="client-button-more-option-div profil" style={{ "backgroundColor": `${primaryColor}`, "textDecoration": "none" }}>
                                    <div className="text-block-53">Prijavi se</div>
                                    <svg className="client-button-more-option-icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#ffff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"></path><polyline points="10 17 15 12 10 7"></polyline><line x1="15" y1="12" x2="3" y2="12"></line></svg>
                                </Link>
                            )}



                        </div>
                    </div>

                </div>
            </div>
        </section>
    );
}
